<div mat-dialog-title class="d-flex justify-content-between align-items-center">
    <h2 class="m-0">Edit member address</h2>
    <button mat-icon-button mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <mat-dialog-content>
   <div class="col-sm-12" style="padding: 0">
      <div class="content" style="">
        <!-- <h1>New business creation (step 4 of 4)</h1> -->
        <div class="sub_headingt">
          <!-- <h3></h3> -->
        </div>
        <div class="map-holder">
          <div
            #mapContainer
            id="map-container"
            style="height: 300px; width: 100%"
          ></div>
        </div>
        <div>
          <p style="color: #888; margin-bottom: 30px">
            Add address where you would like to be served. You can drag the map pointer for a precise location. A well defined address will help the service provider to locate the address correctly.
          </p>
        </div>
        <div class="map-form-holder">
          <!-- <h4>Address</h4> -->
          <mat-form-field appearance="outline">
            <mat-label>Enter location</mat-label>
            <input
              (input)="onInputChange()"
              placeholder="Select a location"
              [matAutocomplete]="auto"
              [(ngModel)]="this.formattedAddress"
              matInput
              #input
            />
            <mat-autocomplete #auto="matAutocomplete">
              <mat-option
                *ngFor="let item of googleAutoCompleteItems"
                (click)="selectItem(item)"
              >
                {{ item.description }}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
        </div>
        <div class="">
          <!-- <h4>Address</h4> -->
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Zipcode</mat-label>
            <input
              [(ngModel)]="this.selectedLocation.zip"
              type="text"
              matInput
              #input
            />
          </mat-form-field>
        </div>
        <div class="">
          <!-- <h4>Address</h4> -->
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>House number</mat-label>
            <input [(ngModel)]="houseNumber" type="text" matInput #input />
          </mat-form-field>
        </div>
        <div class="">
          <!-- <h4>Address</h4> -->
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Street name</mat-label>
            <input [(ngModel)]="streetName" type="text" matInput #input />
          </mat-form-field>
        </div>
        <div class="">
          <!-- <h4>Address</h4> -->
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Landmark</mat-label>
            <input [(ngModel)]="landmark" type="text" matInput #input />
          </mat-form-field>
        </div>
        <div class="">
          <div class="row g-2 justify-content-between phone-field">
            <mat-form-field appearance="outline" class="country-code col-3">
              <mat-label>Country Code</mat-label>
              <mat-select
                [(ngModel)]="contactselectedCountryCode"
                required
                (selectionChange)="onCountrySelected($event)"
              >
                <mat-select-trigger>
                  {{ "(" + contactselectedCountryCode.dial_code + ")" }}
                </mat-select-trigger>

                <mat-option>
                  <ngx-mat-select-search
                    noEntriesFoundLabel="no results found"
                    name="countrysearch"
                    placeholderLabel="Enter country name"
                    [formControl]="searchString"
                    (keyup)="onKey()"
                  ></ngx-mat-select-search>
                </mat-option>
                <mat-option
                  *ngFor="let country of countryList"
                  [value]="country"
                >
                  {{ "(" + country.dial_code + ")" }}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field class="mobile_form col-9" appearance="outline">
              <mat-label>Contact phone</mat-label>
              <input
                matInput
                type="tel"
                [(ngModel)]="phone"
                minLength="3"
                maxlength="17"
              />
              <!-- <mat-hint
        style="color: red; font-size: 13px"
        align="end"
        *ngIf="
          newbookingData.customerPh &&
          newbookingData.customerPh != '' &&
          newbookingData.customerPh.length < 3
        "
        >Enter a valid phone number.</mat-hint 
      >-->
            </mat-form-field>
          </div>
        </div>
      </div>
      <!-- <div class="footer">
      <button mat-button style="font-size: 16px" (click)="onClickBack(4)">
        <mat-icon>arrow_back</mat-icon>
        Back
      </button>
      <button
        (click)="onSubmit()"
        [disabled]="!formattedAddress"
        mat-flat-button
        color="accent"
        class="next"
      >
        Save
      </button>
    </div> -->
    </div>
  </mat-dialog-content>
  
  <mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>Cancel</button>
    <button
      mat-flat-button
      color="accent"
        (click)="onPost()"
    >
      Save
    </button>
  </mat-dialog-actions>
  